import React, { useState, useEffect, useRef }  from 'react';
import styles from 'components/quote_builder_widget/_style.module.scss';
import QuoteBuilderForm from 'components/quote_builder_widget/QuoteBuilderForm.jsx';
import ThreeDPreview from 'components/quote_builder_widget/ThreeDPreview.jsx';
import { GetRequest } from 'components/common/index.js';
import { getTheme } from 'components/quote_builder_widget/themes';

const QuoteBuilderWidget = ( { defaultId, theme: themeName = 'default' } ) => {
  const [id, setId] = useState(defaultId)
  const theme = getTheme(themeName);
  const myRef = useRef();
  const [drawing, setDrawing] = useState({})
  const publishSize = () => {
    if (drawing.catalog_name === undefined) {
      return;
    }

    if (window.parent !== undefined) {
      const message = {
        type: 'diecuttemplates.iframe_set_size',
        data: {
          identifier: drawing.catalog_name,
          width: String(theme.maxWidth || 800),
        },
      };
      window.parent.postMessage(message, "*");
    }
  }

  const getDrawing = () => {
    // https://diecuttemplates.com.dev/drawing-data/72606
    if(id == null) { return }

    GetRequest({
      url: `/drawing-data/${id}`,
      callback: (data) => {
        setDrawing( () => data.drawing)
      }
    })
  }

  const onDrawingFetched = () => {
    if(drawing.catalog_name == undefined) { return }
    console.log({drawing})
    publishSize();
  }
  // useEffect
  useEffect(getDrawing, [id])
  useEffect(onDrawingFetched, [drawing])
  // useEffect

  const Layout = theme.QuoteBuilderLayout;

  return (
    <div ref={myRef}>
      <Layout drawing={drawing}>
        <QuoteBuilderForm
          id={id}
          setId={setId}
          drawing={drawing}
          theme={theme}
        />
      </Layout>
    </div>
  );
}

export default QuoteBuilderWidget;
